require('jquery-validation')
require('jquery-validation/dist/additional-methods')

require('jquery-validation/dist/localization/messages_es')

$.validator.addMethod(
  'accept',
  function (value, element, param) {
    if (this.optional(element) || !element.files || !element.files.length) {
      return true
    }

    const allowed = String(param)
      .split(',')
      .map(item => item.trim().toLowerCase())
      .filter(Boolean)

    return Array.from(element.files).every(file =>
      allowed.some(item => {
        if (item.startsWith('.')) {
          return file.name.toLowerCase().endsWith(item)
        }
        const pattern = item.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*')
        return new RegExp(`^${pattern}$`, 'i').test(file.type || '')
      })
    )
  },
  (param, element) => `Seleccione un archivo permitido (${String(param).replace(/,/g, ', ')}).`
)

function parseAmount(value) {
  return parseFloat(String(value).replace(/,/g, ''))
}

$.validator.addMethod(
  'amount',
  function (value, element) {
    return this.optional(element) || !isNaN(parseAmount(value))
  },
  'Ingrese un monto válido.'
)

$.validator.addMethod(
  'amountMin',
  function (value, element, min) {
    return this.optional(element) || parseAmount(value) >= min
  },
  $.validator.format('El monto debe ser mayor o igual a {0}.')
)

$.validator.addMethod(
  'amountGreaterThan',
  function (value, element, min) {
    return this.optional(element) || parseAmount(value) > min
  },
  $.validator.format('El monto debe ser mayor a {0}.')
)

function isSelect2($element) {
  return $element.hasClass('select2-hidden-accessible')
}

$.validator.setDefaults({
  ignore: ':hidden:not(.select2-hidden-accessible), [disabled]',
  errorElement: 'span',
  errorClass: 'invalid-feedback',
  errorPlacement: function (error, element) {
    error.addClass('d-block')

    if (isSelect2(element)) {
      error.insertAfter(element.next('.select2-container'))
    } else if (element.parent('.input-group').length) {
      error.insertAfter(element.parent())
    } else if (element.is(':radio, :checkbox')) {
      const group = element.closest('.form-check').parent()
      error.appendTo(group.length ? group : element.parent())
    } else {
      error.insertAfter(element)
    }
  },
  highlight: function (element) {
    const $element = $(element)
    if (isSelect2($element)) {
      $element.next('.select2-container').find('.select2-selection').addClass('is-invalid')
    } else if ($element.is(':radio')) {
      $(`input[name="${$element.attr('name')}"]`).addClass('is-invalid')
    } else {
      $element.addClass('is-invalid')
    }
  },
  unhighlight: function (element) {
    const $element = $(element)
    if (isSelect2($element)) {
      $element.next('.select2-container').find('.select2-selection').removeClass('is-invalid')
    } else if ($element.is(':radio')) {
      $(`input[name="${$element.attr('name')}"]`).removeClass('is-invalid')
    } else {
      $element.removeClass('is-invalid')
    }
  },
  invalidHandler: function (event, validator) {
    const first = validator.errorList[0]?.element
    const pane = first ? $(first).closest('.tab-pane') : $()
    if (pane.length && pane.attr('id')) {
      const tab = document.querySelector(`[href="#${pane.attr('id')}"], [data-bs-target="#${pane.attr('id')}"]`)
      if (tab) {
        bootstrap.Tab.getOrCreateInstance(tab).show()
      }
    }
  }
})

window.resetFormValidation = function (form) {
  const validator = $(form).data('validator')
  if (validator) {
    validator.resetForm()
  }
  $(form).find('.is-invalid').removeClass('is-invalid')
  $(form).find('.select2-selection.is-invalid').removeClass('is-invalid')
}

$(document).on('change', 'select.select2-hidden-accessible', function () {
  if (this.form && $(this.form).data('validator')) {
    $(this).valid()
  }
})

$(document).on('input change', 'form :input', function () {
  const validator = this.form ? $(this.form).data('validator') : null
  if (validator && this.name && (this.name in validator.submitted || this.name in validator.invalid)) {
    $(this).valid()
  }
})
